import { OrderItemFragment } from "./order-item";
import { ReceiptFragment } from "./receipt";

export const LocationFragment = /* GraphQL */ `
	fragment LocationFragment on Location {
		_id
		created_at
		updated_at
		venue
		name
		type
		payment_types
		status
		hash
		no_vat
		no_service_charge
		is_pay_later_allowed
		is_pay_now_allowed
		locations_groups_tags
		room_number
		default_order_note
		hidden_items_configs {
			items
			item_types
			categories
			is_items_hide_on_pos
			is_items_hide_on_qr
			is_categories_hide_on_pos
			is_categories_hide_on_qr
			is_item_types_hide_on_pos
			is_item_types_hide_on_qr
		}
		current_headcount
		_current_orders {
			_id
			created_at
			updated_at
			index
			items {
				...OrderItemFragment
			}
			cancelled_items {
				...OrderItemFragment
			}
			prepared_at
			processed_at
			paid_at
			cancelled_at
			prepared_by
			processed_by
			paid_by
			cancelled_by
			customer
			venue
			status
			is_paid
			staff
			original_orders
			cancelled_reason
			source
			device
			prep_time
			currencies_configs
			location
			current_location
			max_prepare_time
			items_count
			items_count_by_types
			prepped_count
			subtotal
			offer_amount
			discount_amount
			net_amount
			vat_amount
			service_charge_amount
			service_charge_bd_amount
			tax_amount
			card_surcharge_amount
			non_sales_credit_amount
			adjustment_amount
			grand_total
			gross_amount
			cancelled_amount
			receipt
			is_needing_prep_time_confirmation
			is_needing_prep_time_acknowledgement
			note
			is_cancelled
			is_bill_printed
			is_needing_payment_confirmation
			headcount
			temp_index
			_receipt {
				...ReceiptFragment
			}
		}
	}
	${OrderItemFragment}
	${ReceiptFragment}
`;
